<template>
  <div
    v-if="showVoidWatermark"
    class="pointer-events-none fixed inset-0 z-50 hidden items-center justify-center print:flex"
  >
    <span
      class="-rotate-45 text-[20rem] font-black tracking-widest opacity-20 select-none"
    >
      VOID
    </span>
  </div>
</template>

<script setup lang="ts">
const config = useRuntimeConfig();

const showVoidWatermark = computed(() => config.public.appEnv !== "production");
</script>
